import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full pt-12 pb-20 md:pt-20 md:pb-32 px-6 overflow-hidden" data-id="element-309">
      <div className="max-w-[1280px] mx-auto" data-id="element-310">
        {/* Brand */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-12 md:mb-20" data-id="element-311">
          <span className="text-primary font-bold tracking-widest text-sm uppercase" data-id="element-312">
            Come Rico Sin Culpa
          </span>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.5fr] gap-12 md:gap-16 items-center" data-id="element-313">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="flex flex-col items-start" data-id="element-314">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-[1.1] mb-6 text-charcoal" data-id="element-315">
              100 Recetas Argentinas para tu Freidora de Aire
            </h1>
            <p className="text-lg md:text-xl text-charcoal/80 mb-8 leading-relaxed" data-id="element-316">
              Paso a paso, con tiempos y temperaturas exactas. Listo en minutos.
            </p>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => document.getElementById('oferta')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-bold uppercase tracking-wider py-4 px-8 rounded-xl shadow-soft transition-colors text-base" data-id="element-317">
              Quiero mi recetario →
            </motion.button>

            <div className="mt-6 flex items-center gap-2 text-sm text-charcoal/70 font-medium" data-id="element-318">
              <div className="flex text-yellow-400" data-id="element-319">
                <Star className="w-4 h-4 fill-current" data-id="element-320" />
              </div>
              <span data-id="element-321">+4.600 descargas verificadas</span>
            </div>
          </motion.div>

          {/* Mockup Area */}
          <motion.div initial={{
          opacity: 0,
          x: 30,
          rotate: 5
        }} animate={{
          opacity: 1,
          x: 0,
          rotate: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="relative w-full max-w-[340px] md:max-w-none mx-auto md:ml-auto" data-id="element-322">
            {/* Decorative background blob */}
            <div className="absolute inset-0 bg-primary/10 rounded-full blur-3xl transform scale-125" data-id="element-323" />

            {/* Kindle Mockup */}
            <div className="relative w-full transform hover:scale-[1.02] transition-transform duration-500" data-id="element-324">
              <img src="https://cdn.magicpatterns.com/uploads/4PQi6YaEUNqZS3i9wY65f2/recetas-air-fryer-argentinas-portada_BUNDLE_sinfondo.png" alt="Recetas Air Fryer Argentinas — bundle tablet, celular y libro" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-325" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}